import { sgwtConnect } from '../../../api/connect';

export default (response: Response): Response => {
  if (response.status === 401) {
    if (!sgwtConnect.isAuthorized()) {
      sgwtConnect.requestAuthorization();
    }
  }

  return response;
};
